<div class="modal-header border-bottom-0">
  <div class="d-inline-block">
    <h5 class="modal-title d-block">{{plan.name}}</h5>
  </div>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [formGroup]="benefitForm" class="modal-body">
  <div *ngFor="let option of plan?.additionalBenefits; let i=index"
       [ngClass]="{'border-bottom': i === plan.additionalBenefits.length - 1}"
       class="border-top border-left border-right px-2 py-3"
  >
    <div class="form-check abc-radio abc-radio-success">
      <input [value]="option.segmentId"
             class="form-check-input"
             formControlName="benefitOption"
             id="benefit-option-{{i}}"
             type="radio">
      <label class="form-check-label"
             for="benefit-option-{{i}}">{{option.descr}}</label>
    </div>
  </div>
</div>
<div class="modal-footer border-top-0 text-center text-md-right">
  <button (click)="activeModal.dismiss('cancel')"
          class="btn btn-outline-success text-capitalize px-5">{{'common.buttonLabels.cancel' | translate}}</button>
  <button (click)="emitSelectionComplete()" [disabled]="benefitForm.invalid"
          class="btn btn-success text-capitalize px-5">{{'common.buttonLabels.done' | translate}}</button>
</div>
